<template>
  <h1>新建合同</h1>
</template>

<script>
export default {
  name: 'NewContract'
}
</script>

<style lang="scss" scoped>

</style>
